import React, { useEffect } from "react";
import BackBtn from "../components/BackBtn";
import SaveBadge from "../components/SaveBadge";
import ActionMenu from "../components/ActionMenu";
import DrillCard from "../components/DrillCard";
import { ArrowBtn, StarBtn } from "../components/ui";
import { FF, T } from "../lib/constants";

// Oefening uit de Training Deck (of de oude lijst extra oefeningen), stijl build 2.5.
export default function DrillDetail({
  mob, pd, lv, sel, selDi, drills, sav, clubId, canEdit,
  setSelDi, setScr, setDrillField, setMoveItem, setMdl, confirmDel,
  renderModal, fav, onToggleFav,
}) {
  var dd = drills[sel] ? drills[sel].find(function (x) { return x.id === selDi; }) : null;

  useEffect(function () {
    if (!dd) setScr("drills");
  }, [dd, setScr]);

  if (!dd) return null;

  var siblings = drills[sel].filter(function (x) { return x.type === "drill" && (x.folderId || null) === (dd.folderId || null); });
  var myIdx = siblings.findIndex(function (x) { return x.id === selDi; });
  var folder = dd.folderId ? drills[sel].find(function (x) { return x.id === dd.folderId; }) : null;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "16px " + pd + "px 48px", fontFamily: FF, boxSizing: "border-box" }}>
      <SaveBadge show={sav} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, position: "relative" }}>
        <BackBtn label={folder ? (folder.name || "Map") : lv.label} onClick={function () { setScr("drills"); }} />
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {onToggleFav && <StarBtn on={fav} label={dd.name || ""} onClick={onToggleFav} size={26} />}
        {canEdit && <ActionMenu style={{ position: "relative", top: 0, right: 0 }} items={[
          { icon: "↗", label: "Verplaatsen naar map…", onClick: function () { setMoveItem(selDi); setMdl("moveTo"); } },
          confirmDel && { icon: "×", label: "Oefening verwijderen", danger: true, onClick: function () { confirmDel("drill", selDi); } },
        ]} />}
        </div>
      </div>
      <DrillCard mob={mob} item={dd} lv={lv} sectionLabel={lv.label} canEdit={canEdit} clubId={clubId}
        onField={function (f, v) { setDrillField(selDi, f, v); }} />
      {siblings.length > 1 && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 14, gap: 12 }}>
          <ArrowBtn dir="left" shadow label="Vorige oefening" disabled={myIdx <= 0} onClick={myIdx > 0 ? function () { setSelDi(siblings[myIdx - 1].id); } : null} />
          <span style={{ fontSize: 13, color: T.muted, fontWeight: 600 }}>{(myIdx + 1) + " van " + siblings.length + (folder ? " in deze map" : "")}</span>
          <ArrowBtn dir="right" shadow label="Volgende oefening" disabled={myIdx >= siblings.length - 1} onClick={myIdx < siblings.length - 1 ? function () { setSelDi(siblings[myIdx + 1].id); } : null} />
        </div>
      )}
      {renderModal()}
    </div>
  );
}
